// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "6c44d60f" : chunkId) + "." + {"229":"d9d529ba164d265e","279":"72219a119586d409"}[chunkId] + ".js";
};